var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F0F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1971_29677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1971_29677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H6V24H24V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1971_29677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23.0625C10.5525 23.0625 6.9375 19.4475 6.9375 15C6.9375 10.5525 10.5525 6.9375 15 6.9375C19.4475 6.9375 23.0625 10.5525 23.0625 15C23.0625 19.4475 19.4475 23.0625 15 23.0625ZM15 8.0625C11.175 8.0625 8.0625 11.175 8.0625 15C8.0625 18.825 11.175 21.9375 15 21.9375C18.825 21.9375 21.9375 18.825 21.9375 15C21.9375 11.175 18.825 8.0625 15 8.0625Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.783 17.9478C17.6855 17.9478 17.588 17.9253 17.498 17.8653L15.173 16.4778C14.5955 16.1328 14.168 15.3753 14.168 14.7078V11.6328C14.168 11.3253 14.423 11.0703 14.7305 11.0703C15.038 11.0703 15.293 11.3253 15.293 11.6328V14.7078C15.293 14.9778 15.518 15.3753 15.7505 15.5103L18.0755 16.8978C18.3455 17.0553 18.428 17.4003 18.2705 17.6703C18.158 17.8503 17.9705 17.9478 17.783 17.9478Z",
    fill: "#002857"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1971_29677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBack);
export default __webpack_public_path__ + "static/media/clock-back.cd95cdd583092b7e15e422e9a0b1a5e7.svg";
export { ForwardRef as ReactComponent };